// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import SoftwareCardGroup from "./com/SoftwareCardGroup";

// Data / Images / Icons
import { SOFTWARE_PROJECTS } from "src/data/pages/softwares";

function P_Software() {
  return (
    <DefaultLayout>
      <TitleBar overrideTitle={`Software: (Total - ${SOFTWARE_PROJECTS.length})`}/>

      <SoftwareCardGroup/>
    </DefaultLayout>
  )
}

export default P_Software